import { ComponentProps, ReactNode } from 'react';
import { CardManagementImage } from './CardManagementImage';

// Column widths from the "Updated Manual" Figma frames.
const TEXT_MAX_WIDTH = 409;
const IMAGE_WIDTH = 303;
const WIDE_IMAGE_WIDTH = 481;

export const CardManagementSection = ({
  children,
  image,
  title,
  separator = false,
  wideImage = false,
}: ComponentProps<typeof CardManagementImage> & {
  children: ReactNode;
  separator?: boolean;
  wideImage?: boolean;
}) => (
  <div className="margin-bottom-20">
    {separator && (
      <div
        className="margin-bottom-20"
        aria-hidden="true"
      >
        –
      </div>
    )}
    <div className="display-flex flex-column flex-row-md gap-50">
      <div
        className="flex-1-1 display-flex flex-column gap-20"
        style={{ maxWidth: TEXT_MAX_WIDTH }}
      >
        {children}
      </div>
      <div
        style={{
          width: wideImage ? WIDE_IMAGE_WIDTH : IMAGE_WIDTH,
          maxWidth: '100%',
          flexShrink: 0,
        }}
      >
        <CardManagementImage
          image={image}
          title={title}
        />
      </div>
    </div>
  </div>
);
